import { useQuery } from 'react-query';
import axios from 'axios';
import { CommissionsDto } from '../models/commission';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 30 — the company-wide commission ledger.
export const getCommissions = async (): Promise<CommissionsDto> => {
  const { data } = await axios.get(`${apiUrl()}Commission`);
  return data;
};

const useCommissions = () => useQuery('commissions', getCommissions);

export default useCommissions;
